/** Машинные коды 422 админ-ролей и менеджера события (#166) → текст для админа. */
const ROLE_ERROR_TEXT: Record<string, string> = {
  unknown_city: 'Город не найден',
  manager_not_city_moderator: 'Пользователь не менеджер города события',
  'cannot grant admin role to fake user': 'Фейку роль не выдаётся',
};

export function roleErrorText(message: string | undefined, fallback: string): string {
  if (!message) return fallback;
  return ROLE_ERROR_TEXT[message] ?? message;
}
